module.exports = __webpack_public_path__ + "img/w1-b1.873f6628.jpg";